module.exports = __webpack_public_path__ + "static/media/logo.fccf7ec2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = 533
// module chunks = 0